import { render, staticRenderFns } from "./YouVsTheWorld.vue?vue&type=template&id=512fd948&scoped=true&"
import script from "./YouVsTheWorld.vue?vue&type=script&lang=js&"
export * from "./YouVsTheWorld.vue?vue&type=script&lang=js&"
import style0 from "./YouVsTheWorld.vue?vue&type=style&index=0&id=512fd948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512fd948",
  null
  
)

export default component.exports